module.exports = __webpack_public_path__ + "static/media/LivWeb_GraceBeck-5.8a2fec47.JPG";